/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Noted API — collaborative human-made music platform
 * OpenAPI spec version: 0.1.0
 */
export interface HealthStatus {
  status: string;
}

export interface Profile {
  id: string;
  displayName: string;
  username?: string | null;
  avatarUrl?: string | null;
  bio?: string | null;
  socialHandle?: string | null;
  isAdmin: boolean;
  unreadDigestOptOut: boolean;
  createdAt: string;
}

export interface CurrentUser {
  authenticated: boolean;
  profile?: Profile | null;
}

export interface UpdateMeBody {
  unreadDigestOptOut?: boolean;
}

export type SongStatus = (typeof SongStatus)[keyof typeof SongStatus];

export const SongStatus = {
  draft: "draft",
  active: "active",
  archived: "archived",
} as const;

export type SongPhase = (typeof SongPhase)[keyof typeof SongPhase];

export const SongPhase = {
  structure: "structure",
  accents: "accents",
} as const;

export interface Song {
  id: string;
  slug: string;
  title: string;
  description?: string | null;
  coverImageUrl?: string | null;
  creatorName: string;
  genre: string;
  bpm: number;
  musicalKey: string;
  timeSignature?: string | null;
  status: SongStatus;
  phase: SongPhase;
  currentVersionId?: string | null;
  createdAt: string;
  updatedAt?: string;
}

export type SongFileFileType =
  (typeof SongFileFileType)[keyof typeof SongFileFileType];

export const SongFileFileType = {
  official_mix: "official_mix",
  stem: "stem",
  click: "click",
  preview: "preview",
  cover: "cover",
  other: "other",
} as const;

export interface SongFile {
  id: string;
  songId: string;
  fileType: SongFileFileType;
  label: string;
  fileUrl: string;
  originalFilename: string;
  sizeBytes?: number | null;
  createdAt: string;
}

export type RoundKind = (typeof RoundKind)[keyof typeof RoundKind];

export const RoundKind = {
  structure: "structure",
  accent: "accent",
} as const;

export type RoundMergeBehavior =
  (typeof RoundMergeBehavior)[keyof typeof RoundMergeBehavior];

export const RoundMergeBehavior = {
  single: "single",
  multi: "multi",
} as const;

export type RoundStatus = (typeof RoundStatus)[keyof typeof RoundStatus];

export const RoundStatus = {
  draft: "draft",
  open: "open",
  closed: "closed",
  merged: "merged",
} as const;

export interface Round {
  id: string;
  songId: string;
  roundNumber: number;
  title: string;
  description?: string | null;
  allowedInstrumentType: string;
  kind: RoundKind;
  mergeBehavior: RoundMergeBehavior;
  status: RoundStatus;
  opensAt?: string | null;
  closesAt?: string | null;
  baseVersionId?: string | null;
  createdAt: string;
  updatedAt?: string;
  commitCount?: number | null;
  totalVotes?: number | null;
}

export interface Version {
  id: string;
  songId: string;
  versionNumber: number;
  title: string;
  description?: string | null;
  officialMixUrl: string;
  isCurrent: boolean;
  createdAt: string;
}

export interface SongCredit {
  id: string;
  songId: string;
  title: string;
  author: string;
  sourceUrl: string;
  licenseName: string;
  licenseUrl: string;
  role?: string | null;
  sortOrder: number;
  createdAt: string;
}

export type SongDetail = Song & {
  currentRound: Round | null;
  currentVersion: Version | null;
  /** The version that the current round is layered against (resolved from currentRound.baseVersionId). Null when there is no open round or the round has no explicit base version. */
  baseVersion: Version | null;
  stems: SongFile[];
  thirdPartyCredits: SongCredit[];
  totalCommits: number;
  totalVotes: number;
  versionCount: number;
  structureRoundsCompleted: number;
  accentRoundsCompleted: number;
};

export interface SongRef {
  id: string;
  slug: string;
  title: string;
}

export type SongCreditWithSong = SongCredit & {
  song: SongRef;
};

export interface FeaturedSong {
  song: SongDetail | null;
}

export type CommitSummaryKind =
  (typeof CommitSummaryKind)[keyof typeof CommitSummaryKind];

export const CommitSummaryKind = {
  structure: "structure",
  accent: "accent",
} as const;

export type CommitSummaryStatus =
  (typeof CommitSummaryStatus)[keyof typeof CommitSummaryStatus];

export const CommitSummaryStatus = {
  pending: "pending",
  shortlisted: "shortlisted",
  merged: "merged",
  rejected: "rejected",
} as const;

export interface ContributorLite {
  id: string;
  displayName: string;
  username?: string | null;
  avatarUrl?: string | null;
  socialHandle?: string | null;
}

export interface CommitSummary {
  id: string;
  songId: string;
  roundId: string;
  contributorId: string;
  title: string;
  note?: string | null;
  instrumentType: string;
  kind: CommitSummaryKind;
  audioFileUrl: string;
  previewMixUrl?: string | null;
  overlayOffsetSeconds: number;
  baseAudioUrl?: string | null;
  status: CommitSummaryStatus;
  voteCount: number;
  hasVoted?: boolean;
  createdAt: string;
  contributor: ContributorLite;
  roundNumber: number;
  songTitle: string;
  songSlug: string;
  songGenre?: string | null;
}

export type CommitDetail = CommitSummary & {
  round: Round;
  mergedIntoVersion?: Version | null;
};

export type VersionMergeCommitKind =
  (typeof VersionMergeCommitKind)[keyof typeof VersionMergeCommitKind];

export const VersionMergeCommitKind = {
  structure: "structure",
  accent: "accent",
} as const;

export interface VersionMerge {
  id: string;
  versionId: string;
  commitId: string;
  contributorId: string;
  mergeNote?: string | null;
  commitTitle: string;
  instrumentType: string;
  commitKind: VersionMergeCommitKind;
  contributor: ContributorLite;
  createdAt: string;
}

export type VersionWithMerges = Version & {
  merges: VersionMerge[];
};

export interface CreditEntry {
  contributor: ContributorLite;
  commitId: string;
  commitTitle: string;
  instrumentType: string;
  versionNumber: number;
  versionId: string;
  versionTitle: string;
  mergeNote?: string | null;
  mergedAt: string;
}

export interface VoteResult {
  commitId: string;
  voteCount: number;
  hasVoted: boolean;
}

export interface GenreStat {
  genre: string;
  songCount: number;
  commitCount: number;
}

export interface PublicStats {
  totalSongs: number;
  totalCommits: number;
  totalVotes: number;
  totalMergedContributors: number;
  genres: GenreStat[];
}

export interface TopContributor {
  contributor: ContributorLite;
  mergedCount: number;
  totalCommits: number;
  totalVotes: number;
}

export interface AdminStats {
  totalSubmissions: number;
  totalVotes: number;
  activeRounds: number;
  pendingCommits: number;
  topContributors: TopContributor[];
}

export type CreateSongBodyStatus =
  (typeof CreateSongBodyStatus)[keyof typeof CreateSongBodyStatus];

export const CreateSongBodyStatus = {
  draft: "draft",
  active: "active",
  archived: "archived",
} as const;

export type CreateSongBodyPhase =
  (typeof CreateSongBodyPhase)[keyof typeof CreateSongBodyPhase];

export const CreateSongBodyPhase = {
  structure: "structure",
  accents: "accents",
} as const;

export interface CreateSongBody {
  slug: string;
  title: string;
  description?: string;
  creatorName: string;
  genre: string;
  bpm: number;
  musicalKey: string;
  timeSignature?: string;
  status?: CreateSongBodyStatus;
  phase?: CreateSongBodyPhase;
}

export type UpdateSongBodyStatus =
  (typeof UpdateSongBodyStatus)[keyof typeof UpdateSongBodyStatus];

export const UpdateSongBodyStatus = {
  draft: "draft",
  active: "active",
  archived: "archived",
} as const;

export type UpdateSongBodyPhase =
  (typeof UpdateSongBodyPhase)[keyof typeof UpdateSongBodyPhase];

export const UpdateSongBodyPhase = {
  structure: "structure",
  accents: "accents",
} as const;

export interface UpdateSongBody {
  title?: string;
  description?: string;
  creatorName?: string;
  genre?: string;
  bpm?: number;
  musicalKey?: string;
  timeSignature?: string;
  status?: UpdateSongBodyStatus;
  phase?: UpdateSongBodyPhase;
  coverImageUrl?: string;
}

export type CreateRoundBodyKind =
  (typeof CreateRoundBodyKind)[keyof typeof CreateRoundBodyKind];

export const CreateRoundBodyKind = {
  structure: "structure",
  accent: "accent",
} as const;

export type CreateRoundBodyMergeBehavior =
  (typeof CreateRoundBodyMergeBehavior)[keyof typeof CreateRoundBodyMergeBehavior];

export const CreateRoundBodyMergeBehavior = {
  single: "single",
  multi: "multi",
} as const;

export type CreateRoundBodyStatus =
  (typeof CreateRoundBodyStatus)[keyof typeof CreateRoundBodyStatus];

export const CreateRoundBodyStatus = {
  draft: "draft",
  open: "open",
  closed: "closed",
  merged: "merged",
} as const;

export interface CreateRoundBody {
  songId: string;
  title: string;
  description?: string;
  allowedInstrumentType: string;
  kind?: CreateRoundBodyKind;
  mergeBehavior?: CreateRoundBodyMergeBehavior;
  status?: CreateRoundBodyStatus;
  opensAt?: string;
  closesAt?: string;
  /** Version this round is layered against. Defaults to the song's current version when omitted. */
  baseVersionId?: string | null;
}

export interface SubmitCommitBody {
  roundId: string;
  /**
   * @minLength 1
   * @maxLength 120
   */
  title: string;
  /** @maxLength 500 */
  note?: string;
  instrumentType: string;
  audioObjectPath: string;
  /** @minimum 0 */
  overlayOffsetSeconds?: number;
  displayNameOverride?: string;
  socialHandle?: string;
  confirmedHumanMade: boolean;
  confirmedRightsGrant: boolean;
}

export interface Comment {
  id: string;
  songId: string;
  authorId: string;
  parentCommentId?: string | null;
  body: string;
  deleted: boolean;
  replyCount: number;
  createdAt: string;
  author: ContributorLite;
}

export interface NotificationItem {
  id: string;
  type: string;
  title: string;
  body?: string | null;
  linkPath: string;
  readAt?: string | null;
  createdAt: string;
  actor?: ContributorLite | null;
  songId?: string | null;
  songTitle?: string | null;
  commentId?: string | null;
}

export interface NotificationFeed {
  /** @minimum 0 */
  unreadCount: number;
  items: NotificationItem[];
}

export interface PostCommentBody {
  /**
   * @minLength 1
   * @maxLength 2000
   */
  body: string;
  parentCommentId?: string | null;
}

export interface ReportCommentBody {
  /**
   * @minLength 1
   * @maxLength 500
   */
  reason: string;
}

export interface CommentReportSummary {
  id: string;
  reason: string;
  createdAt: string;
}

export interface ReportedComment {
  comment: Comment;
  reports: CommentReportSummary[];
  /** @minimum 1 */
  reportCount: number;
}

export interface CommitDraft {
  id: string;
  songId: string;
  contributorId: string;
  title: string;
  note?: string | null;
  instrumentType: string;
  audioFileUrl: string;
  overlayOffsetSeconds: number;
  displayNameOverride?: string | null;
  socialHandle?: string | null;
  confirmedHumanMade: boolean;
  confirmedRightsGrant: boolean;
  createdAt: string;
  updatedAt: string;
  song: Song;
  eligibleRound?: Round | null;
}

export interface CreateDraftBody {
  songId: string;
  /**
   * @minLength 1
   * @maxLength 120
   */
  title: string;
  /** @maxLength 500 */
  note?: string;
  instrumentType: string;
  audioObjectPath: string;
  /** @minimum 0 */
  overlayOffsetSeconds?: number;
  displayNameOverride?: string;
  socialHandle?: string;
  confirmedHumanMade: boolean;
  confirmedRightsGrant: boolean;
}

export interface SubmitDraftBody {
  roundId?: string;
}

/**
 * Patch a saved Note draft. Any omitted field is left unchanged.
 */
export interface UpdateDraftBody {
  /**
   * @minLength 1
   * @maxLength 120
   */
  title?: string;
  /** @maxLength 500 */
  note?: string | null;
  /** @minLength 1 */
  instrumentType?: string;
  /** @minLength 1 */
  audioObjectPath?: string;
  /** @minimum 0 */
  overlayOffsetSeconds?: number;
  displayNameOverride?: string;
  socialHandle?: string;
}

export type AdminAddSongFileBodyFileType =
  (typeof AdminAddSongFileBodyFileType)[keyof typeof AdminAddSongFileBodyFileType];

export const AdminAddSongFileBodyFileType = {
  official_mix: "official_mix",
  stem: "stem",
  click: "click",
  preview: "preview",
  cover: "cover",
  other: "other",
} as const;

export interface AdminAddSongFileBody {
  fileType: AdminAddSongFileBodyFileType;
  label: string;
  fileObjectPath: string;
  originalFilename: string;
  sizeBytes?: number;
}

export interface AdminCreateVersionBody {
  songId: string;
  title: string;
  description?: string;
  mergeNote?: string;
  officialMixObjectPath: string;
  mergedCommitIds: string[];
}

export interface AdminPreviewVersionMixBody {
  songId: string;
  /** @minItems 1 */
  mergedCommitIds: string[];
}

export interface AdminPreviewVersionMixResponse {
  objectPath: string;
  sizeBytes: number;
}

export type RequestUploadUrlBodyPurpose =
  (typeof RequestUploadUrlBodyPurpose)[keyof typeof RequestUploadUrlBodyPurpose];

export const RequestUploadUrlBodyPurpose = {
  "official-mix": "official-mix",
  stem: "stem",
  "commit-audio": "commit-audio",
  cover: "cover",
  avatar: "avatar",
} as const;

export interface RequestUploadUrlBody {
  name: string;
  size: number;
  contentType: string;
  purpose: RequestUploadUrlBodyPurpose;
  songId?: string;
  roundId?: string;
}

export type RequestUploadUrlResponseMetadata = {
  name?: string;
  size?: number;
  contentType?: string;
};

export interface RequestUploadUrlResponse {
  uploadURL: string;
  objectPath: string;
  metadata?: RequestUploadUrlResponseMetadata;
}

export interface CreateSongCreditBody {
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  author: string;
  /** @minLength 1 */
  sourceUrl: string;
  /** @minLength 1 */
  licenseName: string;
  /** @minLength 1 */
  licenseUrl: string;
  role?: string;
  sortOrder?: number;
}

export interface UpdateSongCreditBody {
  /** @minLength 1 */
  title?: string;
  /** @minLength 1 */
  author?: string;
  /** @minLength 1 */
  sourceUrl?: string;
  /** @minLength 1 */
  licenseName?: string;
  /** @minLength 1 */
  licenseUrl?: string;
  role?: string | null;
  sortOrder?: number;
}

export interface ReorderSongCreditsBody {
  creditIds: string[];
}

export type UpdateRoundBodyKind =
  (typeof UpdateRoundBodyKind)[keyof typeof UpdateRoundBodyKind];

export const UpdateRoundBodyKind = {
  structure: "structure",
  accent: "accent",
} as const;

export type UpdateRoundBodyMergeBehavior =
  (typeof UpdateRoundBodyMergeBehavior)[keyof typeof UpdateRoundBodyMergeBehavior];

export const UpdateRoundBodyMergeBehavior = {
  single: "single",
  multi: "multi",
} as const;

export type UpdateRoundBodyStatus =
  (typeof UpdateRoundBodyStatus)[keyof typeof UpdateRoundBodyStatus];

export const UpdateRoundBodyStatus = {
  draft: "draft",
  open: "open",
  closed: "closed",
  merged: "merged",
} as const;

export interface UpdateRoundBody {
  title?: string;
  description?: string;
  allowedInstrumentType?: string;
  kind?: UpdateRoundBodyKind;
  mergeBehavior?: UpdateRoundBodyMergeBehavior;
  status?: UpdateRoundBodyStatus;
  opensAt?: string;
  closesAt?: string;
  /** Version this round is layered against. Pass null to clear. */
  baseVersionId?: string | null;
}

export type AdvancePhaseBodyPhase =
  (typeof AdvancePhaseBodyPhase)[keyof typeof AdvancePhaseBodyPhase];

export const AdvancePhaseBodyPhase = {
  structure: "structure",
  accents: "accents",
} as const;

export interface AdvancePhaseBody {
  phase: AdvancePhaseBodyPhase;
}

export type ListSongsParams = {
  genre?: string;
  status?: ListSongsStatus;
};

export type ListSongsStatus =
  (typeof ListSongsStatus)[keyof typeof ListSongsStatus];

export const ListSongsStatus = {
  draft: "draft",
  active: "active",
  archived: "archived",
} as const;

export type ListCommitsForRoundParams = {
  sort?: ListCommitsForRoundSort;
};

export type ListCommitsForRoundSort =
  (typeof ListCommitsForRoundSort)[keyof typeof ListCommitsForRoundSort];

export const ListCommitsForRoundSort = {
  top: "top",
  newest: "newest",
} as const;

export type ListCommitsParams = {
  songId?: string;
  roundId?: string;
  status?: ListCommitsStatus;
  sort?: ListCommitsSort;
  limit?: number;
};

export type ListCommitsStatus =
  (typeof ListCommitsStatus)[keyof typeof ListCommitsStatus];

export const ListCommitsStatus = {
  pending: "pending",
  shortlisted: "shortlisted",
  merged: "merged",
  rejected: "rejected",
} as const;

export type ListCommitsSort =
  (typeof ListCommitsSort)[keyof typeof ListCommitsSort];

export const ListCommitsSort = {
  top: "top",
  newest: "newest",
} as const;

export type ListRisingCommitsParams = {
  limit?: number;
  genre?: string;
};

export type ReportComment201 = {
  ok: boolean;
};

export type LogDownloadBody = {
  songId: string;
  fileId: string;
};

export type LogDownload200 = {
  ok: boolean;
};

export type AdminListCommitsParams = {
  songId?: string;
  roundId?: string;
  status?: AdminListCommitsStatus;
};

export type AdminListCommitsStatus =
  (typeof AdminListCommitsStatus)[keyof typeof AdminListCommitsStatus];

export const AdminListCommitsStatus = {
  pending: "pending",
  shortlisted: "shortlisted",
  merged: "merged",
  rejected: "rejected",
} as const;

export type AdminSetCommitStatusBodyStatus =
  (typeof AdminSetCommitStatusBodyStatus)[keyof typeof AdminSetCommitStatusBodyStatus];

export const AdminSetCommitStatusBodyStatus = {
  pending: "pending",
  shortlisted: "shortlisted",
  merged: "merged",
  rejected: "rejected",
} as const;

export type AdminSetCommitStatusBody = {
  status: AdminSetCommitStatusBodyStatus;
};
